import { render, staticRenderFns } from "./home-order-tips.vue?vue&type=template&id=7f76afe2&scoped=true&"
import script from "./home-order-tips.vue?vue&type=script&lang=js&"
export * from "./home-order-tips.vue?vue&type=script&lang=js&"
import style0 from "./home-order-tips.vue?vue&type=style&index=0&id=7f76afe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f76afe2",
  null
  
)

export default component.exports